import BordStatus from 'components/NudosComponents/BordStatus/BordStatus';
import LastUpdate from '../../../../../components/LastUpdate/LastUpdate';
import { ORDER_STATUS } from '../../../../../types/orders';
import { IOrderHistory } from '../../../../../types/suscription/history.types';
import { getLastHistoryEvent, createLastEventToDisplayFromHistory } from '../../../../../utils/history';
import { STATUS_VARIANTS, statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';

interface ICurrentOrderStatusDisplay {
  label: string;
  variant: statusVariants;
}

const ORDER_STATUS_DISPLAY_MAP: Record<ORDER_STATUS, ICurrentOrderStatusDisplay> = {
  [ORDER_STATUS.DELIVERED]: { label: 'Entregado', variant: STATUS_VARIANTS.success },
  [ORDER_STATUS.CANCELLED]: { label: 'Cancelado', variant: STATUS_VARIANTS.danger },
  [ORDER_STATUS.ACTIVE]: { label: 'Activo', variant: STATUS_VARIANTS.informative },
  [ORDER_STATUS.PENDING]: { label: 'Por confirmar', variant: STATUS_VARIANTS.default }
};

/**
 * Obtiene objeto con el estado actual de la orden y su variante a renderizar en el componente BordStatus
 * @param statusName - El estado actual de la orden
 * @returns Objeto con el estado actual de la orden y su variante a renderizar
 */
export const getCurrentStatusDisplay = (statusName: ORDER_STATUS): ICurrentOrderStatusDisplay => {
  return ORDER_STATUS_DISPLAY_MAP[statusName] || ORDER_STATUS_DISPLAY_MAP[ORDER_STATUS.PENDING];
};

interface IOrderLastUpdateProps {
  statusName: ORDER_STATUS;
  orderHistory: IOrderHistory[];
  isProblemActive?: boolean;
}

export const OrderLastUpdate = ({ statusName, orderHistory, isProblemActive }: IOrderLastUpdateProps) => {
  const statusDisplay = getCurrentStatusDisplay(statusName);
  const lastEvent = getLastHistoryEvent<IOrderHistory>(orderHistory);
  const lastEventToDisplay = createLastEventToDisplayFromHistory(lastEvent, isProblemActive);

  if (!lastEventToDisplay) {
    return <BordStatus variant={statusDisplay.variant} label={statusDisplay.label} />;
  }

  return (
    <LastUpdate lastEvent={lastEventToDisplay}>
      <BordStatus variant={statusDisplay.variant} label={statusDisplay.label} />
    </LastUpdate>
  );
};
